// src/api/commissions.js
// Functions to interact with the commissions API

/**
 * Submit a commission request
 * @param {Object} requestData Commission request data
 * @returns {Promise<Object>} Response data
 */
export const submitCommissionRequest = async (requestData) => {
  try {
    const response = await fetch('/api/commissions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error submitting commission request:', error);
    throw error;
  }
};